import React from "react";
import { createPortal } from "react-dom";
import { css, cx } from "@emotion/css";
import { defaultOptionMenuHeight, defaultOptionMenuCount, selectOptionsPortalStyle, } from "../../../styles";
const SelectOptionsPortal = ({ children, menuPortalTarget, selectControlRef, optionLength, }) => {
    if (!selectControlRef.current)
        return React.createElement(React.Fragment, null);
    const { width, top, left, bottom: selectControlBottom, } = selectControlRef.current.getBoundingClientRect();
    const { bottom: menuPortalBottom } = menuPortalTarget.getBoundingClientRect();
    const scrollContentHeight = optionLength >= defaultOptionMenuCount
        ? defaultOptionMenuHeight * defaultOptionMenuCount
        : optionLength * defaultOptionMenuHeight;
    let positionTop = top;
    if (menuPortalBottom < selectControlBottom + scrollContentHeight) {
        positionTop -= scrollContentHeight + defaultOptionMenuHeight + 8;
    }
    return createPortal(React.createElement("div", { className: cx("react-auto-scroll-time-select__select-options-portal", css({
            ...selectOptionsPortalStyle,
            width,
            top: positionTop,
            left,
        })) }, children), menuPortalTarget);
};
export default SelectOptionsPortal;
